// src/lib/learn/lesson-complete.ts
//
// When does a lesson count as read? Nobody clicks "done", so the page decides
// from two signals: the student reached the checkpoint at the bottom (scroll),
// and enough time passed for that to have been reading rather than a flick
// through (time). The time bar is half the stated reading time, never under
// thirty seconds and never over three minutes — long enough to exclude a
// bounce, short enough that a fast reader still counts. Pure; the DOM-facing
// hook is src/components/lesson/useLessonComplete.ts.

export const LESSON_COMPLETE_MIN_SECONDS = 30
export const LESSON_COMPLETE_MAX_SECONDS = 180
export const DEFAULT_READ_MINUTES = 3

/** Seconds a student must have been on the page before "reached the end" counts. */
export function minSecondsToComplete(estimatedReadMinutes?: number | null): number {
  const minutes =
    typeof estimatedReadMinutes === 'number' && estimatedReadMinutes > 0
      ? estimatedReadMinutes
      : DEFAULT_READ_MINUTES
  const half = Math.round(minutes * 60 * 0.5)
  return Math.min(LESSON_COMPLETE_MAX_SECONDS, Math.max(LESSON_COMPLETE_MIN_SECONDS, half))
}

export function shouldMarkComplete(input: {
  reachedEnd: boolean
  secondsOnPage: number
  estimatedReadMinutes?: number | null
}): boolean {
  return input.reachedEnd && input.secondsOnPage >= minSecondsToComplete(input.estimatedReadMinutes)
}

/** sessionStorage key that stops a remount within one visit from reporting twice. */
export function completionKey(slug: string): string {
  return `ut_lesson_complete:${slug}`
}
